/* RIPOST · Finder ADAPT (vanilla). v2 22/10/2026: step bar, 27 brands, reviews, video, fixed panel header, lead form. See assets/CUSTOM.txt */
(function () {
  'use strict';
  function mount(root, opts) {
  try {
  if (root._rbf) return root._rbf;
  opts = opts || {}; var modal = opts.mode === 'modal', entry = opts.entry || (modal ? 'header' : 'collection');
  var D = opts.data || JSON.parse(root.querySelector('[data-rbf-data]').textContent);
  var BIKES = D.bikes || [];
  var RANK = {};
  (D.rank || []).forEach(function (h, i) { RANK[String(h).trim()] = i + 1; });
  var PRANK = {};
  (D.prank || []).forEach(function (h, i) { PRANK[String(h).trim()] = i + 1; });
  var byP = function (ps) { return ps.slice().sort(function (a, c) { var x = PRANK[a.u.split('/products/')[1]] || 9999, y = PRANK[c.u.split('/products/')[1]] || 9999; return x - y; }); };
  var BURL = {};
  String(D.brandUrls || '').split('|').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) BURL[kv.slice(0, i)] = kv.slice(i + 1); });

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var scrBrand = $('[data-screen="brand"]'), scrDyn = $('[data-screen="dyn"]'), stepsEl = $('[data-rbf-steps]'), panel = $('[data-rbf-panel]'), body = $('.rbf__body');
  var input = $('[data-rbf-search]'), sug = $('[data-rbf-sug]'), clear = $('[data-rbf-clear]'), top = $('[data-rbf-top]');
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); };
  var rk = function (b) { return RANK[b.h] || 9999; };
  var track = function (name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} };

  function yearLabel(b) {
    var a = b.y1, z = b.y2;
    if (a && z) return a === z ? a : a + ' – ' + z;
    if (a) return a + ' et après';
    if (z) return 'Jusqu’à ' + z;
    return b.v || b.m;
  }
  function yearHint(b) { return (b.y1 || b.y2) && b.v ? b.v : ''; }
  function groups(brand) {
    var map = {}, out = [];
    BIKES.forEach(function (b) {
      if (b.b !== brand) return;
      var k = b.m;
      if (!map[k]) { map[k] = { m: b.m, list: [], r: 9999 }; out.push(map[k]); }
      map[k].list.push(b); map[k].r = Math.min(map[k].r, rk(b));
    });
    out.sort(function (x, y) { return x.r - y.r || x.m.localeCompare(y.m, 'fr'); });
    out.forEach(function (g) { g.label = g.list.length === 1 && g.list[0].v ? g.m + ' ' + g.list[0].v : g.m; g.list.sort(function (x, y) { return (parseInt(y.y1 || y.y2 || 0, 10) - parseInt(x.y1 || x.y2 || 0, 10)) || rk(x) - rk(y); }); });
    return out;
  }
  function brands() {
    var seen = {}, out = [];
    BIKES.forEach(function (b) { if (!seen[b.b]) { seen[b.b] = 1; out.push(b.b); } });
    return out.sort(function (a, c) { return a.localeCompare(c, 'fr'); });
  }
  function choiceKind(ps) {
    var t = ps.map(function (p) { return p.t; }).join(' ');
    if (/\bSP\d{3,}/.test(t)) return 'sp';
    if (/on frame|on seatpost/i.test(t)) return 'mount';
    if (/tige-de-selle-ronde|27[.,]2|31[.,]6/i.test(ps.map(function (p) { return p.u; }).join(' '))) return 'seat';
    return 'ver';
  }
  function choiceLabel(kind, p) {
    var m;
    if (kind === 'sp' && (m = p.t.match(/\b(SP\d{3,})/))) return m[1];
    if (kind === 'mount') return /on frame/i.test(p.t) ? 'Sur le cadre' : 'Sur la tige de selle';
    if (kind === 'seat' && (m = p.t.match(/(27[.,]2|31[.,]6)\s*mm/i))) return m[1].replace('.', ',') + ' mm';
    return p.t.replace(/^ADAPT\s*-\s*/, '');
  }

  /* ---------- rendering ---------- */
  var stack = [];
  function show(state, push) {
    if (push !== false) { stack.push(state); try { if (!modal) history.pushState({ rbf: stack.length }, '', location.href.split('#')[0] + '#finder'); } catch (e) {} }
    // v2c: header (steps, question, search) never moves; only .rbf__body changes. Panel min-height is locked to step 1.
    input.setAttribute('aria-expanded','false'); input.removeAttribute('aria-activedescendant');
    if (input.value || !sug.hidden) { input.value = ''; clear.hidden = true; sug.hidden = true; sug.innerHTML = ''; hits = []; root.classList.remove('rbf--sug'); }
    if (state.s === 'brand') {
      root.classList.remove('rbf--sug');
      scrDyn.hidden = true; scrDyn.innerHTML = ''; scrBrand.hidden = false; root.setAttribute('data-step', 'brand');
      setSteps(1, 'Marque');
      return;
    }
    scrBrand.hidden = true; scrDyn.hidden = false; root.setAttribute('data-step', state.s);
    scrDyn.innerHTML = render(state);
    setSteps(stack.length || 2, stepFor(state));
    // Only when the panel header is scrolled out of view (e.g. brand clicked low in the grid): bring the header back
    // just under the sticky site header. The header itself never moves inside the page.
    var hd = root.querySelector('.rbf__head') || body, sh = document.querySelector('.shopify-section-group-header-group');
    var off = 12 + (sh && /sticky|fixed/.test(getComputedStyle(sh).position) ? sh.offsetHeight : 0); // sticky header reappears on scroll-up
    var ht = hd.getBoundingClientRect().top;
    if (!modal && push !== false && ht < off - 4) window.scrollTo({ top: window.scrollY + ht - off, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    var f = scrDyn.querySelector('.rbf__row,.rbf__c'); if (f && push !== false) f.focus({ preventScroll: true });
  }
  function setSteps(n, label) { if (stepsEl) stepsEl.outerHTML = steps(n, label); stepsEl = $('[data-rbf-steps]'); }
  function lockH() {
    if (!panel || modal) return;
    // Mobile: no height lock (it left a large blank under short steps); the header still never moves.
    if (window.matchMedia('(max-width: 989px)').matches) { panel.style.minHeight = ''; return; }
    if (root.getAttribute('data-step') !== 'brand' || root.classList.contains('rbf--sug')) return;
    panel.style.minHeight = '';
    panel.style.minHeight = Math.ceil(panel.getBoundingClientRect().height) + 'px';
  }
  var STEPN = { models: 'Modèle', years: 'Année' };
  function steps(n, label) {
    n = Math.min(n, 3);
    var b = '';
    for (var k = 1; k <= 3; k++) b += '<i' + (k <= n ? ' class="is-on"' : '') + '></i>';
    return '<p class="rbf__steps" data-rbf-steps aria-live="polite"><span>Étape ' + n + '/3 · ' + esc(label) + '</span><span class="rbf__bar" aria-hidden="true">' + b + '</span></p>';
  }
  function stepFor(st) {
    if (STEPN[st.s]) return STEPN[st.s];
    var k = choiceKind(st.items || []);
    return k === 'sp' ? 'Référence' : k === 'mount' ? 'Montage' : k === 'seat' ? 'Diamètre' : 'Version';
  }
  function back(label) { return '<button type="button" class="rbf__back" data-act="back">‹ ' + esc(label) + '</button>'; }
  function row(act, i, label, hint, url) {
    return '<li><' + (url ? 'a href="' + esc(url) + '"' : 'button type="button"') + ' class="rbf__row" data-act="' + act + '" data-i="' + i + '"><span>' + esc(label) + (hint ? '<small>' + esc(hint) + '</small>' : '') + '</span><i aria-hidden="true">›</i></' + (url ? 'a' : 'button') + '></li>';
  }
  function render(st) {
    var h = '';
    if (st.s === 'others') {
      st.items = brands().filter(function (b) { return (D.top || []).map(function (x) { return String(x).trim(); }).indexOf(b) < 0; });
      h = back('Marques') + '<h2 class="rbf__q">Autre marque</h2><ul class="rbf__list">' + st.items.map(function (b, i) { return row('brand', i, b); }).join('') + '</ul>';
    } else if (st.s === 'models') {
      st.items = groups(st.brand);
      h = back(st.from === 'others' ? 'Autres marques' : 'Marques') + '<h2 class="rbf__q">Quel modèle&nbsp;?</h2><p class="rbf__sub">' + esc(st.brand) + '</p><ul class="rbf__list">' + st.items.map(function (g, i) { return row('model', i, g.label, '', g.list[0].url); }).join('') + '</ul>';
    } else if (st.s === 'years') {
      st.items = st.group.list;
      h = back(st.group.list[0].b) + '<h2 class="rbf__q">Quelle année&nbsp;?</h2><p class="rbf__sub">' + esc(st.group.m) + '</p><ul class="rbf__list">' + st.items.map(function (b, i) { return row('bike', i, yearLabel(b), yearHint(b), b.url); }).join('') + '</ul>';
    } else if (st.s === 'choice') {
      var k = choiceKind(st.items);
      var q = k === 'sp' ? 'Référence de votre tige&nbsp;?' : k === 'mount' ? 'Où le fixer&nbsp;?' : k === 'seat' ? 'Diamètre de votre tige&nbsp;?' : 'Quelle version&nbsp;?';
      var sub = k === 'sp' ? esc(st.title) + ' · gravée sous le collier' : esc(st.title);
      var withImg = k === 'mount' || k === 'seat';
      h = back(st.backLabel) + '<h2 class="rbf__q">' + q + '</h2><p class="rbf__sub">' + sub + '</p>';
      if (withImg) {
        h += '<ul class="rbf__cards">' + st.items.map(function (p, i) { return '<li><a href="' + esc(p.u) + '" class="rbf__c" data-act="go" data-i="' + i + '">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="80" height="80" loading="eager">' : '') + '<b>' + esc(choiceLabel(k, p)) + '</b><i aria-hidden="true">›</i></a></li>'; }).join('') + '</ul>';
      } else {
        h += '<ul class="rbf__list">' + st.items.map(function (p, i) { return row('go', i, choiceLabel(k, p), '', p.u); }).join('') + '</ul>';
      }
    }
    return h;
  }
  function go(url, data) {
    track('rbf_redirect', data || {});
    root.classList.add('is-going');
    window.location.href = url;
  }
  function pickBike(b, backLabel) {
    try { if (window.RipostBikes) RipostBikes.add(RipostBikes.fromData(b)); } catch (e) {}
    track('rbf_bike_added', {entry:entry, handle:b.h});
    if (modal) {
      show({s:'success'}, false); setSteps(3, 'Vélo ajouté');
      stepsEl.querySelector('span').textContent = '✓ Vélo ajouté';
      root.querySelector('.rbf__search').hidden = true;
      var foot = root.querySelector('.rbf__foot'); if (foot) foot.hidden = true;
      scrDyn.innerHTML = '<div class="rbf__ok"><span class="rbf__tick">✓</span><h3>Vélo ajouté à Mes vélos</h3><p>' + esc(b.l || b.b + ' ' + b.m) + '</p></div><a class="rbf__cta rp-btn rp-btn--block" data-rbf-accessories href="' + esc(b.url) + '">Voir les accessoires compatibles</a><button type="button" class="rbf__cta2 rp-btn rp-btn--secondary rp-btn--block" data-rbf-continue>Continuer mes achats</button>';
      if (opts.onDone) opts.onDone(b); return;
    }
    if (!b.p || !b.p.length) return go(b.url, {handle:b.h});
    if (b.p.length === 1) return go(b.p[0].u, { bike: b.h });
    var g = groups(b.b).filter(function (x) { return x.m === b.m; })[0];
    var title = g && g.list.length > 1 ? b.m + ' ' + yearLabel(b) : (b.v ? b.m + ' ' + b.v : b.m);
    show({ s: 'choice', items: byP(b.p), title: title, bike: b, backLabel: backLabel || b.m });
  }
  function pickGroup(g) {
    if (g.list.length === 1) return pickBike(g.list[0], g.list[0].b);
    show({ s: 'years', group: g });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-brand]');
    if (a && top.contains(a)) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      track('rbf_brand_selected', { entry:entry, step:'brand' });
      return show({ s: 'models', brand: a.getAttribute('data-brand') });
    }
    if (e.target.closest('[data-rbf-others]')) return show({ s: 'others' });
    if (e.target.closest('[data-rbf-seat]')) {
      if (D.seat && D.seat.length) show({ s: 'choice', items: byP(D.seat), title: 'Tige de selle ronde', backLabel: 'Marques' });
      return;
    }
    var b = e.target.closest('[data-act]');
    if (!b) return;
    if (b.tagName === 'A') { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return; e.preventDefault(); }
    var st = stack[stack.length - 1], i = +b.getAttribute('data-i'), act = b.getAttribute('data-act');
    if (act === 'back') { if (modal) { if (stack.length > 1) stack.pop(); show(stack[stack.length - 1], false); } else history.back(); return; }
    if (act === 'brand') return show({ s: 'models', brand: st.items[i], from: 'others' });
    if (act === 'model') { track('rbf_model_selected',{entry:entry,step:'model'}); return pickGroup(st.items[i]); }
    if (act === 'bike') { track('rbf_year_selected',{entry:entry,handle:st.items[i].h,step:'year'}); return pickBike(st.items[i], st.group.m); }
    if (act === 'go') return go(st.items[i].u, { bike: st.bike ? st.bike.h : 'seat' });
  });
  window.addEventListener('popstate', function () {
    if (modal) return;
    if (stack.length > 1) { stack.pop(); show(stack[stack.length - 1], false); }
    else if (stack.length === 1) { stack = [{ s: 'brand' }]; show(stack[0], false); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) root.classList.remove('is-going'); });
  stack = [{ s: 'brand' }];

  /* ---------- type-ahead ---------- */
  var IDX = BIKES.map(function (b) {
    var same = BIKES.filter(function (x) { return x.b === b.b && x.m === b.m; }).length > 1;
    return { b: b, k: ' ' + norm([b.b, b.m, b.v, b.y1, b.y2].join(' ')) + ' ', km: ' ' + norm(b.m + ' ' + b.v) + ' ', label: same ? b.m + ' · ' + yearLabel(b) + (yearHint(b) ? ' (' + yearHint(b) + ')' : '') : (b.v ? b.m + ' ' + b.v : b.m) };
  });
  var hits = [];
  function search(q) {
    var n = norm(q);
    if (n.length < 2) { input.setAttribute('aria-expanded','false'); input.removeAttribute('aria-activedescendant'); sug.hidden = true; sug.innerHTML = ''; hits = []; root.classList.remove('rbf--sug'); return; }
    var terms = n.split(' ');
    var bl = brands().filter(function (x) { return norm(x).indexOf(n) === 0; }).slice(0, 2);
    hits = IDX.filter(function (x) { return terms.every(function (t) { return x.k.indexOf(' ' + t) >= 0 || x.k.indexOf(t) >= 0; }); })
      .map(function (x) { return { x: x, s: (x.km.indexOf(' ' + terms[0]) >= 0 ? 0 : 1) * 10000 + rk(x.b) }; })
      .sort(function (a, c) { return a.s - c.s; }).slice(0, bl.length ? 5 : 6).map(function (o) { return o.x; });
    var h = bl.map(function (b, i) { return '<li><button type="button" class="rbf__row" data-sb="' + i + '"><span><small class="rbf__pre">Marque</small>' + esc(b) + '</span><i aria-hidden="true">›</i></button></li>'; }).join('');
    h += hits.map(function (x, i) { return '<li><a href="' + esc(x.b.url) + '" class="rbf__row" data-sh="' + i + '"><span><small class="rbf__pre">' + esc(x.b.b) + '</small>' + esc(x.label) + '</span><i aria-hidden="true">›</i></a></li>'; }).join('');
    if (!h) { h = noResult(q); track('rbf_no_results',{entry:entry}); }
    highlighted = -1; input.removeAttribute('aria-activedescendant');
    sug.innerHTML = h; Array.prototype.forEach.call(sug.querySelectorAll('[data-sb],[data-sh]'), function(el,i) { el.id = input.id + '-option-' + i; el.setAttribute('role','option'); el.setAttribute('aria-selected','false'); }); sug.hidden = false; input.setAttribute('aria-expanded','true'); sug._bl = bl; root.classList.add('rbf--sug');
  }
  /* QA 24/10/2026: no-result state = « Aucun résultat pour « … ». » + way out to the « Je ne trouve pas mon vélo » form (query escaped, capped at 60 chars; French wording from data-none) */
  function noResult(q) {
    var tpl = sug.getAttribute('data-none'), v = String(q).trim().slice(0, 60);
    var msg = tpl && tpl.indexOf('{q}') >= 0 ? tpl.split('{q}').map(esc).join('<b>' + esc(v) + '</b>') : 'Aucun résultat';
    var lead = lDlg && typeof lDlg.showModal === 'function' ? '<button type="button" class="rbf__nlead" data-sl data-rbf-lead>' + esc(lBtn ? lBtn.textContent.trim() : 'Je ne trouve pas mon vélo') + ' ›</button>' : '';
    return '<li class="rbf__none"><span>' + msg + '</span>' + lead + '</li>';
  }
  var tmr, highlighted = -1;
  input.setAttribute('role','combobox'); input.setAttribute('aria-expanded','false'); input.setAttribute('aria-autocomplete','list'); sug.id = input.id + '-results'; input.setAttribute('aria-controls',sug.id);
  input.addEventListener('input', function () { clear.hidden = !input.value; clearTimeout(tmr); tmr = setTimeout(function () { search(input.value); }, 150); });
  input.addEventListener('focus', function () {
    root.classList.add('is-typing');
    if (!modal && window.matchMedia('(max-width: 989px)').matches) { var r = input.getBoundingClientRect(); if (r.top > 200) window.scrollTo({ top: window.scrollY + r.top - 150, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
  });
  input.addEventListener('keydown', function(e) {
    var rows = sug.querySelectorAll('[role="option"]');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!rows.length || sug.hidden) return; e.preventDefault();
      highlighted = (highlighted + (e.key === 'ArrowDown' ? 1 : rows.length - 1) + rows.length) % rows.length;
      Array.prototype.forEach.call(rows,function(el,i){el.setAttribute('aria-selected',String(i === highlighted));});
      input.setAttribute('aria-activedescendant',rows[highlighted].id); rows[highlighted].scrollIntoView({block:'nearest'});
    } else if (e.key === 'Enter') { e.preventDefault(); if (!sug.hidden && highlighted >= 0 && rows[highlighted]) rows[highlighted].click(); }
  });
  clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; search(''); input.focus(); });
  sug.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sb],[data-sh],[data-sl]'); if (!b) return;
    if (b.tagName === 'A') { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return; e.preventDefault(); }
    if (b.hasAttribute('data-sl')) { track('rbf_search_nolead', { entry:entry }); return; }
    if (b.hasAttribute('data-sb')) { track('rbf_brand_selected',{entry:entry,step:'brand'}); track('rbf_search', { entry:entry }); return show({ s: 'models', brand: sug._bl[+b.getAttribute('data-sb')] }); }
    var x = hits[+b.getAttribute('data-sh')]; if (!x) return;
    track('rbf_search', { entry:entry, handle:x.b.h });
    pickBike(x.b, x.b.m);
  });

  /* ---------- v2: short placeholder on narrow fields ---------- */
  var phLong = input.getAttribute('placeholder'), phShort = input.getAttribute('data-ph-short');
  function fitPh() { if (phShort && phLong) input.setAttribute('placeholder', input.clientWidth && input.clientWidth < 300 ? phShort : phLong); }
  fitPh(); window.addEventListener('resize', fitPh);

  /* v2c: carousel dots removed (Maxime); cards stay swipeable on mobile. */
  lockH(); window.addEventListener('load', lockH); window.addEventListener('resize', function () { if (panel) panel.style.minHeight = ''; lockH(); });

  /* ---------- v2b: ADAPT video lightbox (sources loaded on click only) ---------- */
  var vOpen = $('[data-rbf-vopen]'), vDlg = $('[data-rbf-vdlg]');
  if (vOpen && vDlg && typeof vDlg.showModal === 'function') {
    var vid = vDlg.querySelector('video'), vClose = vDlg.querySelector('[data-rbf-vclose]'), vLoaded = false;
    var load = function () {
      if (vLoaded) return; vLoaded = true;
      if (vid.getAttribute('data-poster')) vid.poster = vid.getAttribute('data-poster');
      // data-src = "format~height~url|…" (Liquid video.sources). Order: HLS where native (iOS Safari), then MP4 closest to 720p.
      var list = String(vid.getAttribute('data-src') || '').split('|').map(function (x) { var p = x.split('~'); return p.length === 3 ? { f: p[0], h: +p[1] || 0, u: p[2].trim() } : null; }).filter(function (x) { return x && x.u; });
      var hls = list.filter(function (x) { return x.f === 'm3u8'; });
      var mp4 = list.filter(function (x) { return x.f === 'mp4'; }).sort(function (a, c) { return Math.abs(a.h - 720) - Math.abs(c.h - 720) || a.h - c.h; });
      var add = function (u, t) { var so = document.createElement('source'); so.src = u; so.type = t; vid.appendChild(so); };
      if (hls.length && vid.canPlayType('application/vnd.apple.mpegurl')) add(hls[0].u, 'application/vnd.apple.mpegurl');
      mp4.forEach(function (x) { add(x.u, 'video/mp4'); });
      vid.preload = 'auto'; vid.load();
    };
    vOpen.addEventListener('click', function () {
      load();
      vDlg.showModal();
      document.documentElement.classList.add('rbf-vlock');
      vClose.focus({ preventScroll: true });
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
      track('rbf_video_open', {});
    });
    var shut = function () { if (vDlg.open) vDlg.close(); };
    vClose.addEventListener('click', shut);
    vDlg.addEventListener('click', function (e) { if (e.target === vDlg || e.target.classList.contains('rbf__vbox')) shut(); });
    vDlg.addEventListener('cancel', function () { /* Esc: native close */ });
    vDlg.addEventListener('close', function () {
      vid.pause();
      document.documentElement.classList.remove('rbf-vlock');
      vOpen.focus({ preventScroll: true });
    });
    vDlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lDlg && lDlg.classList.contains('is-nm')) { e.preventDefault(); lDlg.close(); return; }
      if (e.key !== 'Tab') return;
      var f = [vClose, vid], i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
    });
  }

  /* ---------- v2c: « Je ne trouve pas mon vélo » lead modal (Shopify contact form) ---------- */
  var lBtn = $('[data-rbf-lead]'), lDlg = document.querySelector('[data-rbf-ldlg]');
  root._leadContext = function(){ for(var k=stack.length-1;k>=0;k--){var st=stack[k]; if(st.group)return {b:st.group.list[0].b,m:st.group.m}; if(st.brand)return {b:st.brand,m:''};} return {b:'',m:input.value.trim()}; };
  bindLead();
  function reset(){ stack=[{s:'brand'}]; root.querySelector('.rbf__search').hidden=false; var foot=root.querySelector('.rbf__foot'); if(foot)foot.hidden=false; show(stack[0],false); }
  root._rbf = {reset:reset, openBrand:function(b){show({s:'models',brand:b});}, openModel:function(b,m){show({s:'models',brand:b}); var g=groups(b).filter(function(g){return g.m===m;})[0]; if(g)pickGroup(g);}, focusSearch:function(){input.focus();}, setEntry:function(e){entry=e;}};
  return root._rbf;
  } catch(e) { return null; }
  }
  function bindLead(){
  var lDlg=document.querySelector('[data-rbf-ldlg]'), lBtn=null;
  var track=function(n,p){try{if(window.Shopify && Shopify.analytics)Shopify.analytics.publish(n,p||{});}catch(e){}};
  if (lDlg && !lDlg._bound && typeof lDlg.showModal === 'function') {
    lDlg._bound=true;
    var lForm = lDlg.querySelector('form'), lErr = lDlg.querySelector('[data-rbf-lerr]'), lSub = lDlg.querySelector('[data-rbf-lsub]');
    var lStepF = lDlg.querySelector('[data-rbf-lstep="form"]'), lStepOk = lDlg.querySelector('[data-rbf-lstep="ok"]'), lNative = false, lSkip = false;
    var DRAFT = 'rbf_lead_draft', DF = ['name', 'email', 'Marque', 'Modèle', 'Année'];
    var fld = function (n) { return lForm.querySelector('[name="contact[' + n + ']"]'); };
    var saveDraft = function () { try { var o = {}; DF.forEach(function (n) { var el = fld(n); if (el) o[n] = el.value; }); sessionStorage.setItem(DRAFT, JSON.stringify(o)); } catch (x) {} };
    var loadDraft = function () { try { var o = JSON.parse(sessionStorage.getItem(DRAFT) || 'null'); if (o) DF.forEach(function (n) { var el = fld(n); if (el && !el.value && o[n]) el.value = o[n]; }); } catch (x) {} };
    var dropDraft = function () { try { sessionStorage.removeItem(DRAFT); } catch (x) {} };
    // Shopify hCaptcha renders its challenge in the normal page; a showModal() dialog (top layer + inert page) would hide it.
    // So when the captcha takes over, the same dialog is re-opened non-modal (below the challenge's z-index).
    var toNonModal = function () {
      if (lDlg.classList.contains('is-nm')) return;
      lDlg.classList.add('is-nm'); lSkip = true; lDlg.close(); var parent=document.getElementById('RbfModal'); if(parent && parent.open){parent.close(); lDlg._parent=parent;} lDlg.show();
    };
    var ctx = function () { var r=lBtn && lBtn.closest('[data-rbf]'); return r && r._leadContext ? r._leadContext() : {b:lBtn && lBtn.getAttribute('data-brand') || '', m:lBtn && lBtn.getAttribute('data-model') || ''}; };
    var focusables = function () { return Array.prototype.filter.call(lDlg.querySelectorAll('button,input:not([type=hidden]),textarea:not([hidden]),[tabindex="0"]'), function (el) { return el.offsetParent !== null && !el.disabled; }); };
    var openLead = function (ok) {
      lStepF.hidden = !!ok; lStepOk.hidden = !ok; lErr.hidden = true;
      if (!ok) {
        var c = ctx(), fb = lForm.querySelector('[data-rbf-lbrand]'), fm = lForm.querySelector('[data-rbf-lmodel]');
        if (c.b && !fb.value) fb.value = c.b;
        if (c.m && !fm.value) fm.value = c.m;
        loadDraft();
      }
      if (lDlg.open) { lSkip = true; lDlg.close(); }
      lDlg.classList.remove('is-nm'); lDlg.showModal(); document.documentElement.classList.add('rbf-vlock');
      var f = ok ? lDlg.querySelector('[data-rbf-lok]') : lForm.querySelector('input[name="contact[name]"]');
      if (f) f.focus();
      if (!ok) track('velo_lead_open', {});
    };
    document.addEventListener('click',function(e){var b=e.target.closest('[data-rbf-lead]');if(b){lBtn=b;openLead(false);}});
    lDlg.addEventListener('click', function (e) { if (e.target === lDlg || e.target.closest('[data-rbf-lclose]')) lDlg.close(); });
    lDlg.addEventListener('close', function () {
      if (lSkip) { lSkip = false; if (!lDlg.open) lDlg.classList.remove('is-nm'); else return; }
      if (lDlg.open) return;
      lDlg.classList.remove('is-nm'); lSub.removeAttribute('aria-busy'); document.documentElement.classList.remove('rbf-vlock'); if(lDlg._parent){lDlg._parent.showModal();document.documentElement.classList.add('rbf-ui-lock');lDlg._parent=null;} if(lBtn) lBtn.focus({ preventScroll: true }); });
    lDlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lDlg && lDlg.classList.contains('is-nm')) { e.preventDefault(); lDlg.close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    var fail = function (msg) { lErr.textContent = msg; lErr.hidden = false; lSub.disabled = false; lSub.removeAttribute('aria-busy'); };
    lForm.addEventListener('submit', function (e) {
      var g = function (n) { var el = lForm.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; };
      lForm.querySelector('[data-rbf-lbody]').value = '[Finder] Vélo introuvable\nPrénom : ' + g('name') + '\nEmail : ' + g('email') + '\nMarque : ' + g('Marque') + '\nModèle : ' + g('Modèle') + '\nAnnée : ' + (g('Année') || '-') + '\nPage : ' + location.href.split('#')[0];
      try { sessionStorage.setItem('rbf_lead', JSON.stringify({ brand: g('Marque'), model: g('Modèle') })); } catch (x) {}
      if (lNative) return; // fallback: normal post
      // Shopify storefront hCaptcha bound to this form: let it run the (invisible) check, then it posts natively
      // and Shopify redirects back here with ?contact_posted=true#RbfLeadForm (success state shown on load).
      if (lForm.getAttribute('data-hcaptcha-bound')) { lErr.hidden = true; lSub.setAttribute('aria-busy', 'true'); saveDraft(); toNonModal(); return; }
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      lErr.hidden = true; lSub.disabled = true; lSub.setAttribute('aria-busy', 'true');
      fetch(lForm.action, { method: 'POST', body: new FormData(lForm), credentials: 'same-origin', redirect: 'follow', headers: { Accept: 'text/html' } })
        .then(function (r) {
          var u = r.url || '';
          if (/\/challenge/.test(u)) { lNative = true; lForm.submit(); return; }
          if (r.ok && /contact_posted=true/.test(u)) {
            try { sessionStorage.removeItem('rbf_lead'); } catch (x) {} dropDraft();
            track('velo_lead_submitted', {entry:'collection'});
            lStepF.hidden = true; lStepOk.hidden = false; lSub.disabled = false; lSub.removeAttribute('aria-busy');
            var ok = lDlg.querySelector('[data-rbf-lok]'); if (ok) ok.focus();
            lForm.reset();
            return;
          }
          return r.text().then(function (t) {
            if (/name="h-captcha|hcaptcha/i.test(t)) { lNative = true; lForm.submit(); return; }
            fail(/email/i.test(t) && /errors?/i.test(t) ? 'Vérifiez votre adresse email.' : 'L’envoi a échoué. Réessayez ou écrivez-nous à contact@ripostshop.com.');
          });
        })
        .catch(function () { fail('Connexion impossible. Réessayez ou écrivez-nous à contact@ripostshop.com.'); });
    });
    if (/contact_posted=true/.test(location.search) && /RbfLeadForm/.test(location.hash)) {
      dropDraft(); var sv = null; try { sv = JSON.parse(sessionStorage.getItem('rbf_lead') || 'null'); sessionStorage.removeItem('rbf_lead'); } catch (x) {}
      if (sv) (function fire(n) { // Shopify.analytics may not be ready yet right after the redirect
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) track('velo_lead_submitted', {entry:'collection'});
        else if (n < 50) setTimeout(function () { fire(n + 1); }, 100);
      })(0);
      openLead(true);
    }
  }
  }
  window.RBF={mount:mount};
  function boot(){document.querySelectorAll('[data-rbf]:not([data-rbf-mode]),[data-rbf][data-rbf-mode="inline"]').forEach(function(r){mount(r,{mode:'inline',entry:'collection'});}); bindLead();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
